import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const heading_main = 'Mutugi Craig Mutegi.';
const sub_heading = 'Aspiring Software Engineer & a Computer Science student.';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { 
      when: "beforeChildren",
      staggerChildren: 0.5,
      duration: 0.5
    }
  }
};

const textContainerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.2
    }
  }
};

const letterVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 12,
      stiffness: 200
    }
  }
};

const TextReveal = ({ text, className, delay = 0 }) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      if (currentIndex <= text.length) {
        setDisplayedText(text.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(intervalId);
      }
    }, 50); // Adjust typing speed here

    return () => clearInterval(intervalId);
  }, [text]);

  return (
    <motion.span 
      variants={textContainerVariants} 
      initial="hidden"
      animate="visible"
      className={className}
      style={{ display: 'inline-block' }}
    >
      {displayedText.split('').map((char, index) => (
        <motion.span key={index} variants={letterVariants}>
          {char}
        </motion.span>
      ))}
    </motion.span>
  );
};

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div 
          key="home"
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={containerVariants}
          className='flex flex-col items-center justify-center min-h-screen p-4 md:p-8 lg:ml-[18em] overflow-hidden'
        >
          <div className='flex flex-col justify-center items-center w-full max-w-4xl lg:max-w-none'>
            <div className='flex flex-col justify-center items-center mb-10 lg:mb-0'>
              <TextReveal 
                text={heading_main}
                className='font-dancing text-4xl sm:text-5xl md:text-6xl lg:text-[6em] mb-8 lg:mb-28 mt-8 lg:mt-[1em] text-center'
              />
              <TextReveal 
                text={sub_heading}
                className='font-suwannaphum text-xl sm:text-2xl md:text-3xl lg:text-[2em] font-light text-center'
                delay={1.5}
              />
            </div>
            <motion.hr 
              variants={{
                hidden: { width: 0 },
                visible: { 
                  width: "100%",
                  transition: { duration: 1.5, ease: "easeInOut" }
                }
              }}
              className='w-full lg:w-[80%] my-8 lg:mt-[6.5em] border-black' 
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Home;